import "core-js/modules/es.array.push.js";
import { useApiErrorToast } from 'app/api/app-api/apiHooksHelpers';
import { useFormatUserDate } from "../../core/useFormatUserDate";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Button, Checkbox, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, Text, TooltipOnHover, propStyling, tombac, useTombac } from 'tombac';
import { RefreshIcon, WarningIcon } from 'tombac-icons';
import { getContractDisplayName } from "../contractHelpers";
import { useReassignContractUsers } from "../contractsApiHooks";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ContractAssignOverlapsModal = _ref => {
  let {
    isRefreshing,
    onAssign,
    onRequestClose,
    onRequestRefresh,
    overlaps,
    targetContractId,
    ...props
  } = _ref;
  const addApiErrorToast = useApiErrorToast();
  const formatDate = useFormatUserDate();
  const tombac = useTombac();
  const [selected, setSelected] = useState([]);

  // When overlaps change, remove users that are no longer overlapping
  useEffect(() => {
    setSelected(selected => selected.filter(email => overlaps.find(overlap => overlap.user.email === email)));
  }, [overlaps]);
  const [error, setError] = useState(undefined);
  const {
    isLoading: isReassigning,
    mutateAsync: reassignContractUsers
  } = useReassignContractUsers();
  const overlapsByUser = overlaps.reduce((acc, overlap) => {
    if (!acc[overlap.user.email]) {
      acc[overlap.user.email] = [];
    }
    acc[overlap.user.email].push(overlap);
    return acc;
  }, {});
  const overlappingEmails = Object.keys(overlapsByUser);
  const overlapsCount = overlappingEmails.length;
  const handleSelectAllChange = event => {
    setSelected(event.target.checked ? overlappingEmails : []);
  };
  const handleSelectionChange = email => {
    setSelected(selected.includes(email) ? selected.filter(item => item !== email) : [...selected, email]);
  };
  const handleAssign = async () => {
    if (selected.length === 0) {
      setError('Please select at least one user');
      return;
    }
    try {
      await reassignContractUsers(selectedOverlapsToReassign(overlaps, selected, targetContractId));
    } catch (e) {
      addApiErrorToast(e);
      return;
    }
    onAssign();
  };
  return /*#__PURE__*/_jsx(Modal, {
    ...props,
    "data-sentry-element": "Modal",
    "data-sentry-component": "ContractAssignOverlapsModal",
    "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      size: "l",
      "data-sentry-element": "ModalLayout",
      "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
      "data-sentry-element": "ModalLayout",
      children: [/*#__PURE__*/_jsxs(ModalHeader, {
        "data-sentry-element": "ModalHeader",
        "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
        "data-sentry-element": "ModalHeader",
        children: ["We found overlapping contract(s) for ", overlaps.length, " user(s). Do you want to assign users to this contract?"]
      }), /*#__PURE__*/_jsxs(ModalContent, {
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
        "data-sentry-element": "ModalContent",
        children: [/*#__PURE__*/_jsxs(Box, {
          $alignItems: "center",
          $display: "flex",
          $gap: "2sp",
          $mb: "2sp",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
          "data-sentry-element": "Box",
          children: [/*#__PURE__*/_jsx(WarningIcon, {
            color: tombac.color('alert'),
            "data-sentry-element": "WarningIcon",
            "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
            "data-sentry-element": "WarningIcon"
          }), /*#__PURE__*/_jsx(Text, {
            "data-sentry-element": "Text",
            "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
            "data-sentry-element": "Text",
            children: "Please note: By assigning users to this contract, they will be automatically unassigned from the previous contract(s)."
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          $alignItems: "center",
          $display: "flex",
          $gap: "2sp",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
          "data-sentry-element": "Box",
          children: [/*#__PURE__*/_jsx(Checkbox, {
            checked: selected.length === overlapsCount,
            indeterminate: selected.length > 0 && selected.length < overlapsCount,
            label: "Select all",
            onChange: handleSelectAllChange,
            "data-sentry-element": "Checkbox",
            "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
            "data-sentry-element": "Checkbox"
          }), /*#__PURE__*/_jsx(Box, {
            $ml: "auto",
            "data-sentry-element": "Box",
            "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
            "data-sentry-element": "Box",
            children: /*#__PURE__*/_jsx(TooltipOnHover, {
              content: "Refresh the list",
              placement: "top",
              size: "s",
              "data-sentry-element": "TooltipOnHover",
              "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
              "data-sentry-element": "TooltipOnHover",
              children: /*#__PURE__*/_jsx(Button, {
                busy: isRefreshing,
                onClick: onRequestRefresh,
                shape: "circle",
                size: "s",
                variant: "flat",
                "data-sentry-element": "Button",
                "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
                "data-sentry-element": "Button",
                children: /*#__PURE__*/_jsx(RefreshIcon, {
                  "data-sentry-element": "RefreshIcon",
                  "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
                  "data-sentry-element": "RefreshIcon"
                })
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(ModalContent, {
        $mt: "1sp",
        variant: "scrollable",
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
        "data-sentry-element": "ModalContent",
        children: /*#__PURE__*/_jsx(UserList.Root, {
          "data-sentry-element": "unknown",
          "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
          "data-sentry-element": "unknown",
          children: Object.entries(overlapsByUser).map(_ref2 => {
            let [email, overlaps] = _ref2;
            return /*#__PURE__*/_jsx(UserList.Item, {
              children: /*#__PURE__*/_jsxs(UserList.Label, {
                children: [/*#__PURE__*/_jsxs(UserList.User, {
                  children: [/*#__PURE__*/_jsx(Checkbox, {
                    checked: selected.includes(email),
                    label: false,
                    onChange: () => handleSelectionChange(email)
                  }), /*#__PURE__*/_jsx(UserList.Text, {
                    title: email,
                    children: email
                  })]
                }), /*#__PURE__*/_jsx(UserList.ContractList, {
                  children: overlaps.map(overlap => /*#__PURE__*/_jsxs(UserList.ContractItem, {
                    children: [/*#__PURE__*/_jsx(UserList.ContractLink, {
                      target: "_blank",
                      title: getContractDisplayName(overlap.contract),
                      to: `/contracts/${overlap.contract.id}`,
                      children: getContractDisplayName(overlap.contract)
                    }), /*#__PURE__*/_jsxs(UserList.Text, {
                      $flexShrink: "0",
                      $textAlign: "right",
                      children: ["valid ", formatDate(overlap.contract.startDate), " -", ' ', formatDate(overlap.contract.endDate)]
                    })]
                  }, `${overlap.contract.id}${overlap.user.email}`))
                })]
              })
            }, email);
          })
        })
      }), /*#__PURE__*/_jsxs(ModalActions, {
        secondary: error && /*#__PURE__*/_jsx(Text, {
          $alignSelf: "center",
          as: "span",
          variant: "danger",
          children: error
        }),
        "data-sentry-element": "ModalActions",
        "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
        "data-sentry-element": "ModalActions",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onRequestClose,
          variant: "secondary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
          "data-sentry-element": "Button",
          children: "Don't assign"
        }), /*#__PURE__*/_jsx(Button, {
          busy: isReassigning,
          onClick: handleAssign,
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ContractAssignOverlapsModal.tsx",
          "data-sentry-element": "Button",
          children: "Assign selected users"
        })]
      })]
    })
  });
};
function selectedOverlapsToReassign(overlaps, selected, targetContractId) {
  const assign = [{
    id: targetContractId,
    users: selected.map(email => ({
      email
    }))
  }];
  const unassign = [];
  for (const overlap of overlaps) {
    if (!selected.includes(overlap.user.email)) continue;
    const contract = unassign.find(contract => contract.id === overlap.contract.id);
    if (contract) {
      contract.users.push(overlap.user);
    } else {
      unassign.push({
        id: overlap.contract.id,
        users: [overlap.user]
      });
    }
  }
  return {
    assign,
    unassign
  };
}
const UserList = {
  ContractLink: styled(Link).withConfig({
    displayName: "ContractAssignOverlapsModal__ContractLink"
  })(["color:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], _ref3 => {
    let {
      theme
    } = _ref3;
    return theme.colors.accent[500];
  }),
  ContractItem: styled.div.withConfig({
    displayName: "ContractAssignOverlapsModal__ContractItem"
  })(["display:flex;gap:", ";"], tombac.space(2)),
  ContractList: styled.div.withConfig({
    displayName: "ContractAssignOverlapsModal__ContractList"
  })(["display:flex;flex:auto;flex-direction:column;min-width:0;"]),
  Item: styled.li.withConfig({
    displayName: "ContractAssignOverlapsModal__Item"
  })([""]),
  Label: styled.label.withConfig({
    displayName: "ContractAssignOverlapsModal__Label"
  })(["align-items:flex-start;cursor:default;display:flex;gap:", ";margin:", ";padding:", ";transition:background-color 0.1s ease-out;&:hover{background-color:", ";}& [class*='TombacStyledCheckbox']{display:block;}"], tombac.space(2), tombac.space(0, -3), tombac.space(0.5, 3), tombac.color('neutral', 300)),
  Root: styled.ul.withConfig({
    displayName: "ContractAssignOverlapsModal__Root"
  })(["list-style:none;margin:0;padding:0;"]),
  Text: styled.span.withConfig({
    displayName: "ContractAssignOverlapsModal__Text"
  })(["color:", ";flex:auto;overflow:hidden;text-align:", ";text-overflow:ellipsis;white-space:nowrap;", ""], tombac.color('neutral', 700), _ref4 => {
    let {
      $textAlign
    } = _ref4;
    return $textAlign;
  }, propStyling),
  User: styled.div.withConfig({
    displayName: "ContractAssignOverlapsModal__User"
  })(["align-items:center;display:flex;flex:0 0 auto;gap:", ";width:35%;"], tombac.space(1.5))
};